SWR.Social.prototype._loadTwitch = function _loadTwitch() {
  var self = this;
  try {
    var twitchRegEx = /(^https?:)?\/\/(www\.)?twitch\.tv\/(?=videos\/(?<video>[a-zA-Z0-9.]+)|collections\/(?<collection>[a-zA-Z0-9.]+)|(?<channel>[\w\.]{2,}))/gm;

    var twitchFrameWidth = 854;
    var twitchFrameHeight = 480;

    var twitchFrameUrl = new URL('https://embed.twitch.tv');
    twitchFrameUrl.searchParams.set('autoplay', false);
    twitchFrameUrl.searchParams.set('parent', window.location.hostname);
    twitchFrameUrl.searchParams.set('referrer', window.location.href);
    twitchFrameUrl.searchParams.set('width', twitchFrameWidth);
    twitchFrameUrl.searchParams.set('height', twitchFrameHeight);

    var twitchRegExResult = twitchRegEx.exec(self.config.url);
    if (twitchRegExResult.groups.channel) {
      twitchFrameUrl.searchParams.set('channel', twitchRegExResult.groups.channel);
    } else if (twitchRegExResult.groups.video) {
      twitchFrameUrl.searchParams.set('video', twitchRegExResult.groups.video);
    } else if (twitchRegExResult.groups.collection) {
      twitchFrameUrl.searchParams.set('collection', twitchRegExResult.groups.collection);
    }
    twitchFrameUrl.searchParams.sort();

    var html = COMMON.Utils.template('<div class="embed-responsive embed-responsive-16by9">' +
      '<iframe src="{src}" loading="lazy" class="embed-responsive-item" allowfullscreen scrolling="no" frameborder="0" allow="autoplay; fullscreen" title="Twitch" sandbox="allow-modals allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-storage-access-by-user-activation" width="{width}" height="{height}"></iframe>' +
      '</div>', {
      'src': twitchFrameUrl.toString(),
      'width': twitchFrameWidth,
      'height': twitchFrameHeight
    });
    self._done(html);
  } catch (exception) {
    self._failed(self.config.embedCookie, self.url);
  }
};
